import React from "react"
import { ReactQueryProvider } from "~/components/ReactQueryProvider"
import { CookiesProvider } from "react-cookie"
import { AppRoutes } from "./routes"
import { ModalProvider } from "./contexts/ModalProvider"
import { NotificationProvider } from "./contexts/NotificationProvider"
import { CampProvider } from "./contexts/CampProvider"
import { GlobalLoaderProvider } from "./contexts/GlobalLoaderProvider"

const App: React.FC = () => {
  return (
    <ReactQueryProvider>
      <CookiesProvider>
        <CampProvider>
          <GlobalLoaderProvider>
            <NotificationProvider>
              <ModalProvider>
                <AppRoutes />
              </ModalProvider>
            </NotificationProvider>
          </GlobalLoaderProvider>
        </CampProvider>
      </CookiesProvider>
    </ReactQueryProvider>
  )
}

export default App
